import { inject, Injectable } from '@angular/core';
import { BaseParamsService } from '../base-params.service';
import { ApiTranslationsAttributes } from '../_models/api-translations';
import { Observable } from 'rxjs';
import { Translations } from '@app/shared/models/translations';
import { ConsentsTranslations } from '@app/shared/models/consents-translations';
import { map, switchMap } from 'rxjs/operators';
import { SchemaTranslations } from '@app/shared/models/schema-translations';
import { TranslatorService } from './translator.service';

@Injectable()
export class TranslationsService {
  private readonly baseParamsService = inject(BaseParamsService);
  private readonly translatorService = inject(TranslatorService);

  public getTranslations(attributes: ApiTranslationsAttributes[]): Observable<Translations> {
    return this.getAttributesTranslations(attributes);
  }

  public getConsentTranslations(): Observable<ConsentsTranslations> {
    return this.getAttributesTranslations([ApiTranslationsAttributes.consents])
      .pipe(
        map(t => t.getConsentsTranslations()),
      );
  }

  public getSchemaTranslations(): Observable<SchemaTranslations> {
    return this.getAttributesTranslations([
      ApiTranslationsAttributes.consents,
      ApiTranslationsAttributes.member_properties,
    ]).pipe(
      map(t => t.getSchemaTranslations()),
    );
  }

  private getAttributesTranslations(attributes: ApiTranslationsAttributes[]): Observable<Translations> {
    return this.getCurrentLanguage().pipe(
      switchMap((language) => this.translatorService.getTranslations(language || '', attributes)),
    );
  }

  private getCurrentLanguage(): Observable<string | undefined> {
    return this.baseParamsService.getParamsResolvedObservable().pipe(
      switchMap(() => this.baseParamsService.language$),
    );
  }


}
